module.exports = __webpack_public_path__ + "img/button_down.fb78dc94.svg";